import { Action } from 'redux';

export class PayloadAction implements Action {
  type: string;
  newState?: any;
}

/*
 * This payload state 'healthScreening' is generated dynamically when the form and page are created
 * 
 * The only reason we need this reducer is to apply an entire saved 'healthScreening' state from an existing application.
 * Since this is all abstract, we can't infer anything about the initial state other than it is an object
*/
const INITIAL_STATE: any = {};

export const INIT_PAYLOAD = 'INIT_PAYLOAD';
export const RESET_STATE = 'RESET_HEALTH_SCREENING_STATE';
export const SAVE_HEALTH_SCREENING = 'SAVE_HEALTH_SCREENING';

export function loadExistingHealthScreeningIntoState(state: any): PayloadAction {
  return {
    type: SAVE_HEALTH_SCREENING,
    newState: state
  };
}

export function healthScreening(state: any = INITIAL_STATE, action: PayloadAction) {
  switch (action.type) {
    case SAVE_HEALTH_SCREENING:
        return Object.assign({}, action.newState);
    case RESET_STATE:
        return INITIAL_STATE;
    case INIT_PAYLOAD:
    default:
        return state;
  }
}

